import React from 'react';
import moment from 'moment';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

import WidgetBase, { BaseList } from './WidgetBase';
import Badge from '../Badge';

import { classNames } from '../helpers/functions';

import useAsync from '../../hooks/useAsync';
import useModal from '../../hooks/useModal';

import { getEventsByAsset } from '../../api';

const TimelineWidget = ({ ...data }) => {
	const { setOpen: onOpenEvent } = useModal('eventDetails');
	const { setOpen: openAddEvent } = useModal('eventAdd');
	const { value: upcomingEvents } = useAsync(getEventsByAsset, {
		defaultPayload: {
			startDate: moment().startOf('day').toDate(),
			status: ['ESTIMATED', 'SCHEDULED'],
			assetId: data?.item?.id,
		},
		silent: true,
	});

	return (
		<WidgetBase
			cols={2}
			title="Upcoming"
			menuItems={[
				{ name: 'View all', onClick: () => {} },
				{
					name: 'Add service',
					onClick: () => openAddEvent({ assetId: data?.item?.id }),
				},
			]}
			isEmpty={!upcomingEvents?.length}
			isEmptyMessage={'No upcoming services'}
			flexCenter={!upcomingEvents?.length}
		>
			<BaseList
				items={upcomingEvents
					?.filter((event) => {
						const type = event?.type;
						const isPMCategory =
							event?.category?.key === 'default:pm' &&
							event?.category?.isDefault;
						const isOverdue = moment().isAfter(
							event?.scheduledDate || event?.estimatedDate
						);

						return !(type === 'event.single' && isOverdue && !isPMCategory);
					})
					.map((event) => {
						//const isExpired = moment().isAfter(contract?.endDate);

						const isOverdue = moment().isAfter(
							event?.scheduledDate || event?.estimatedDate
						);

						return {
							children: (
								<div
									className="grid grid-cols-2 gap-x-6 flex-1 py-2 cursor-pointer"
									onClick={() => onOpenEvent({ id: event?.id })} //openContractModal({ id: contract?.id })}
								>
									<div className="font-base flex items-center">
										<div className="w-24 -mt-1">
											{event?.status === 'SCHEDULED' && (
												<Badge
													status={isOverdue ? 'error' : 'success'}
													isBeta
													className="mt-1 text-xxs"
												>
													Scheduled
												</Badge>
											)}
											{event?.status === 'ESTIMATED' && (
												<Badge
													status={isOverdue ? 'error' : 'default'}
													isBeta
													className="mt-1 text-xxs"
												>
													Estimated
												</Badge>
											)}
										</div>

										{moment(
											event?.status === 'ESTIMATED'
												? event?.estimatedDate
												: event?.scheduledDate
										).format('ddd, MMM Do, YYYY')}
									</div>
									<div
										className={classNames(
											'flex justify-between items-center text-gray-500'
										)}
									>
										{event?.title || event?.service?.name}
										<div>
											<ChevronRightIcon className="text-gray-500 w-3 h-3" />
										</div>
									</div>
								</div>
							),
						};
					})}
			/>{' '}
		</WidgetBase>
	);
};

export default TimelineWidget;
